import { useEffect, useState } from "react";

import SliderHome from "../components/Slide/SliderHome";
import ProductListHome from "../components/products/ProductsListHome";
import Certificate from "../components/certificate/certificate";
import BestSellProd from "../components/bestSell/bestSellProd";
import ShortIntro from "../components/shortIntro/ShortIntro";
import NewsOnHomePage from "../components/NewsOnHomePage";
import Timeline from "../components/Timeline/Time_line";
// hieu ung noel
// import Snowfall from "react-snowfall";
import ChristmasEffect from "../components/NoelEffect/AnimatedGift";

// image list For timeline
const images = ["/images/timeline/tl1.jpg", "/images/timeline/tl2.jpg"];

function HomePage() {
  useEffect(() => {
    document.title = "Mễ Mễ Việt Nam";
  }, []);

  // state for timeline
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  // open gallery photo when click in Timeline
  const openGalleryPhoto = () => {
    setSelectedImages(images);
    setIsOpen(true);
  };

  return (
    <div className="position-relative">
      <SliderHome />
      <Timeline onOpen={openGalleryPhoto} />
      <ProductListHome />
      <Certificate />
      <NewsOnHomePage />
      <BestSellProd />

      <ShortIntro />
      {/* tạo hiệu ứng noel tuyết rơi */}
      {/* <Snowfall
        // Adjust number of snowflakes
        snowflakeCount={550}
        // Optional: Set snowflake color
        color="white"
        // Optional: Control layering
        style={{ zIndex: 10 }}
      /> */}
      {/* <ChristmasEffect /> */}

      {/* Timeline,  show photo gallery when click in Timeline */}
      {isOpen && (
        <div className="modal" onClick={() => setIsOpen(false)}>
          <div className="modal-content">
            <span className="close" onClick={() => setIsOpen(false)}>
              &times;
            </span>
            {selectedImages.map((img, index) => (
              <img
                key={index}
                className="modal-image"
                src={img}
                alt={`img-${index}`}
                style={{ width: "100%", marginBottom: "10px" }}
              />
            ))}
          </div>
        </div>
      )}
      {/*Timeline- CSS Modal Styles when click on Timeline */}
      <style>
        {`
          .modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            overflow-y: auto; /* ✅ Scrollable if needed */
            padding: 20px; /* ✅ Prevents cutoff */
            z-index: 1000;
          }

          .modal-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            max-width: 90%;
            max-height: 90vh; /* ✅ Ensures modal fits screen */
            overflow-y: auto; /* ✅ Scrolls if content is too long */
            text-align: center;
            position: relative;
          }

           .modal-image {
            max-width: 100%;
            max-height: 80vh; /* ✅ Ensures image fits in screen */
            margin-bottom: 10px;
            object-fit: contain; /* ✅ Prevents image from being cut off */
          }

          .close {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 24px;
            cursor: pointer;
            color: red;
            background-color: white;
            border-radius: 50%;
          }
        `}
      </style>
    </div>
  );
}

export default HomePage;
